var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.6665 10.7319V9.26523C1.6665 8.39856 2.37484 7.6819 3.24984 7.6819C4.75817 7.6819 5.37484 6.61523 4.6165 5.3069C4.18317 4.5569 4.4415 3.5819 5.19984 3.14856L6.6415 2.32356C7.29984 1.9319 8.14984 2.16523 8.5415 2.82356L8.63317 2.9819C9.38317 4.29023 10.6165 4.29023 11.3748 2.9819L11.4665 2.82356C11.8582 2.16523 12.7082 1.9319 13.3665 2.32356L14.8082 3.14856C15.5665 3.5819 15.8248 4.5569 15.3915 5.3069C14.6332 6.61523 15.2498 7.6819 16.7582 7.6819C17.6248 7.6819 18.3415 8.39023 18.3415 9.26523V10.7319C18.3415 11.5986 17.6332 12.3152 16.7582 12.3152C15.2498 12.3152 14.6332 13.3819 15.3915 14.6902C15.8248 15.4486 15.5665 16.4152 14.8082 16.8486L13.3665 17.6736C12.7082 18.0652 11.8582 17.8319 11.4665 17.1736L11.3748 17.0152C10.6248 15.7069 9.3915 15.7069 8.63317 17.0152L8.5415 17.1736C8.14984 17.8319 7.29984 18.0652 6.6415 17.6736L5.19984 16.8486C4.4415 16.4152 4.18317 15.4402 4.6165 14.6902C5.37484 13.3819 4.75817 12.3152 3.24984 12.3152C2.37484 12.3152 1.6665 11.5986 1.6665 10.7319Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 12.7057C11.4956 12.7057 12.7082 11.4932 12.7082 9.9974C12.7082 8.50162 11.4956 7.28906 9.99984 7.28906C8.50407 7.28906 7.2915 8.50162 7.2915 9.9974C7.2915 11.4932 8.50407 12.7057 9.99984 12.7057Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon16);
export default __webpack_public_path__ + "static/media/menu-icon-16.7d3cbd7d9b07b15744a1625cb1138352.svg";
export { ForwardRef as ReactComponent };